import emitter from "events";

const eventEmitter = new emitter();

const defaultListener = (): void => {
};

eventEmitter.setMaxListeners(100000);

export const EventEmitter = {
	on: (event: string, fn: (value: any) => void) => eventEmitter.on(event, fn),
	once: (event: string, fn: (value: any) => void) => eventEmitter.once(event, fn),
	off: (event: string, fn?: (value: any) => void) => eventEmitter.off(event, fn || defaultListener),
	emit: (event: string, payload: any) => eventEmitter.emit(event, payload),
	listenerCount: (event: string) => eventEmitter.listenerCount(event),
};

Object.freeze(EventEmitter);
